// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"building-4"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M20 3V9H21V21H3V9H12V3H20Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M9 21V15H15V21H9Z"}},{"tag":"g","attrs":{"id":"stroke2"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M9 21V15H15V21H9Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M15 5.99805H15.0039V6.00195H15V5.99805Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 3V9H20V3M12 3H20M12 3H11M20 3H21M3 9V21H21V9H3Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Building4Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'building-4',
    ref,
    icon: element,
  },
));

Building4Icon.displayName = 'Building4Icon';

export default Building4Icon;
